/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".drop-panel[_ngcontent-%COMP%]{width:100%}.drop-panel[_ngcontent-%COMP%]   .divider-title[_ngcontent-%COMP%]{width:100%;border-bottom:2px solid #edeff0;font-weight:400;padding:0 5px 5px;margin-bottom:10px;font-size:1.17em!important}.drop-panel[_ngcontent-%COMP%]   .divider-title[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#000}.file-preview-box[_ngcontent-%COMP%]{grid-template-columns:repeat(auto-fill,minmax(180px,1fr))}.file-preview-box[_ngcontent-%COMP%]   .file-preview[_ngcontent-%COMP%]{height:150px}"];
export { styles as styles };
